module.exports = __webpack_public_path__ + "assets/img/thumb-Coolabah-Turf-Article.99014e20.webp";